export default __webpack_public_path__ + "static/media/contact-us-bg.2cc7eb67.jpg";